import { Component } from "@angular/core";
@Component({
  selector: "app-homes",
  templateUrl: "./homes.component.html",
  styleUrls: ["./homes.component.css"],
})
export class HomesComponent {
  title = "homes";
  public items: Array<object>;
  constructor() {
    this.items = [
      {
        home_title: "Lenox-1",
        home_detail: "Ml14XC1S036, CX35-48B, ML180UH090E48B",
        contractor_detail: "HAVC Contractor ID: 57",
      },
      {
        home_title: "Lenox-2",
        home_detail: "Ml14XC1S036, CX35-48B, ML180UH090E48B",
        contractor_detail: "HAVC Contractor ID: 58",
      },
      {
        home_title: "Lenox-3",
        home_detail: "Ml14XC1S036, CX35-48B, ML180UH090E48B",
        contractor_detail: "HAVC Contractor ID: 59",
      },
      {
        home_title: "Lenox-4",
        home_detail: "Ml14XC1S036, CX35-48B, ML180UH090E48B",
        contractor_detail: "HAVC Contractor ID: 60",
      },
      {
        home_title: "Lenox-5",
        home_detail: "Ml14XC1S036, CX35-48B, ML180UH090E48B",
        contractor_detail: "HAVC Contractor ID: 61",
      },
      {
        home_title: "Lenox-6",
        home_detail: "Ml14XC1S036, CX35-48B, ML180UH090E48B",
        contractor_detail: "HAVC Contractor ID: 62",
      },
    ];
  }

  home_title = "";
  titleError = "";

  onTitleChange(event: any) {
    this.home_title = event.target.value;
  }

  public Add(event) {
    let homeData = {
      home_title: this.home_title,
      home_detail: "Ml14XC1S036, CX35-48B, ML180UH090E48B",
      contractor_detail: `HAVC Contractor ID: ${Math.ceil(
        Math.random() * 100
      )}`,
    };
    if (this.home_title) {
      this.items.push(homeData);
      alert("Home Added Successfully");
      this.home_title = "";
      this.titleError = "";
    } else {
      this.titleError = "Please Enter Title";
    }
  }
}
